import { guardClient } from '../_axios'

/**
 * タスクの移動（カラム変更・並び順更新）
 * [patch]/tasks/move
 */
export type MoveTaskRequest = {
  taskId: string
  targetColumnId: string
  position: number
}

export const moveTask = async (request: MoveTaskRequest) => {
  const path = '/tasks/move'
  const response = await guardClient.patch(path, request)
  return response.data
}
